const texts = {
  offer: {
    standard: "offer",
    changeIf: (session) => session.isExternal,
    changeTo: "assignment",
  },
};

export default function swapText(key, session) {
  const text = texts[key];

  return text.changeIf(session) ? text.changeTo : text.standard;
}
